import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const objectiveDefinition: ResourceDefinition = {
  title: 'Objectives',
  nameSingular: 'Objective',
  namePlural: 'Objectives',
  className: 'Objective',
  mainIdentifier: 'name',
  slug: 'taxonomies/objectives',
  path: 'objectives',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (objective) => ({
        type: ActionType.Link,
        link: {
          path: `${objectiveDefinition.path}/${objective.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (objective) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: objective,
          definition: objectiveDefinition
        }
      })
    }
  ]
}
